import * as React from 'react'

import { Box, HeaderText, Text } from '@factorialco/deprecated-design-system'
import { F0Box, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { useEsignatureF0 } from 'modules/documents/components/DocumentPreview/Content/Esignature/useEsignatureF0Context'

interface Props {
  description?: string
}

const Title = ({ description }: Props) => {
  const useF0 = useEsignatureF0()

  if (useF0) {
    return (
      <F0Box paddingTop="lg" gap="sm">
        <F0Text variant="body" content={i18n.t('documents.modal.esignature.title')} />
        {description && <F0Text variant="small" content={description} />}
      </F0Box>
    )
  }

  return (
    <Box gap="s8">
      <HeaderText text={i18n.t('documents.modal.esignature.title')} />
      {description && (
        <Text size="300" color="grey800">
          {description}
        </Text>
      )}
    </Box>
  )
}

export default Title
